import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconCross from 'components/icons/IconCross';
import IconButton from 'components/common/IconButton';

import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';

const styles = () => ({
  root: {
    padding: 0,
    display: 'block',
    marginTop: 20,
  },
  gridItem: {
    display: 'flex',
  },
  listItemSecondaryAction: {
    top: 20,
    right: -15,
  },
  iconCross: {
    width: 11,
    height: 11,
  },
});

const OrderInformationVitalsField = ({ Vitals, input, onRemove, classes }) => {
  const vitalsItem = Vitals.find(item => item.ID === input.value);
  if (!vitalsItem) {
    return '';
  }
  return (
    <ListItem
      className={classes.root}
      disableGutters
    >
      <Grid
        container
        justify="flex-start"
        spacing={24}
      >
        <Grid
          className={classes.gridItem}
          item
        >
          <Typography
            component="span"
            color="secondary"
          >
            W
          </Typography>
          {'\u00A0'}
          <Typography
            component="span"
          >
            {vitalsItem.Weight}{'\u00A0'}lb
          </Typography>
        </Grid>
        <Grid
          className={classes.gridItem}
          item
        >
          <Typography
            component="span"
            color="secondary"
          >
            H
          </Typography>
          {'\u00A0'}
          <Typography
            component="span"
          >
            {vitalsItem['Height Ft']}ft
            {vitalsItem['Height In'] > 0 && (
              `,\u00A0${vitalsItem['Height In']}in`
            )}
          </Typography>
        </Grid>
        <Grid
          className={classes.gridItem}
          item
        >
          <Typography
            component="span"
            color="secondary"
          >
            BMI
          </Typography>
          {'\u00A0'}
          <Typography
            component="span"
          >
            {vitalsItem.BMI}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        justify="space-between"
        spacing={8}
      >
        <Grid item>
          <Typography
            component="span"
            variant="caption"
          >
            {moment(vitalsItem['Create At'], timeDateFormat).format(dateFormat)}
          </Typography>
        </Grid>
      </Grid>
      <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
        <IconButton
          aria-label="Remove"
          onClick={onRemove}
          tooltipContent="Remove"
        >
          <IconCross className={classes.iconCross} />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

OrderInformationVitalsField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.number,
  }).isRequired,
  Vitals: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    BMI: PropTypes.number.isRequired,
    'Create At': PropTypes.string.isRequired,
    'Height Ft': PropTypes.number.isRequired,
    'Height In': PropTypes.number.isRequired,
    Weight: PropTypes.number.isRequired,
  })).isRequired,
  onRemove: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    gridItem: PropTypes.string.isRequired,
    listItemSecondaryAction: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(OrderInformationVitalsField);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationVitals/OrderInformationVitalsField.js